// extracted by mini-css-extract-plugin
export default {"creditItem":"style_creditItem__bbvvO","redImgCredit":"style_redImgCredit__J9ers","redCreditImage":"style_redCreditImage__OGPe-","creditInfoTitle":"style_creditInfoTitle__5DntK"};